/**
 * Default bank account for payment forms: prefers config DefaultBankAccount
 * (exposed as company.defaultBankAccount) when it matches a row; otherwise first account.
 */
export function resolveDefaultBankAccountCode(
	accounts: Array<{ accountcode?: string | number }> | null | undefined,
	preferred?: string | null
): string {
	if (!accounts?.length) {
		return '';
	}
	const want = (preferred ?? '').toString().trim();
	if (want) {
		const hit = accounts.find((a) => String(a?.accountcode) === want);
		if (hit) {
			return String(hit.accountcode);
		}
	}
	return String(accounts[0].accountcode);
}
